export default __webpack_public_path__ + "static/media/transmitter.141fbe21.webp";